// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__lrZRq","close":"Modal_close__stDBq","edit":"Modal_edit__KN7LE","title":"Modal_title__6whQx"};